<template lang="pug">
  div.d-flex
    div.mr-2(v-for="(tier, tierIndex) in tiers" :key="tier.id" style="width: 85px")
      p.mb-2.label.basic600--text {{ tier.name }}
      v-text-field.centered-input(v-model.number="tier.commission_value" hide-details="auto" dense outlined height="40" background-color="basic200" :suffix="suffix(tier)" :prefix="prefix(tier)" type="number" :rules="rules.required_or_null" :class="valueChanged || focused ? 'value-changed' : ''")
    div.d-flex.align-end
      v-btn(v-if="!parentNoValues" x-small depressed height="40" style="background-color: var(--v-dangerT08); border: solid 1px var(--v-danger500)" @click="$emit('unapply')")
        .button-Aa-small.danger500--text Un-apply
</template>

<script>
export default {
  name: 'ProductTiersInput',
  props: {
    tiers: {
      type: Array,
      required: true
    },
    focused: {
      type: Boolean
    },
    parentNoValues: {
      type: Boolean
    },
    valueChanged: {
      type: Boolean
    }
  },
  data() {
    return {
      rules: {
        required_or_null: [v => !v || v >= 0 || 'Positive value only']
      },
    }
  },
  methods: {
    prefix(tier) {
      if (tier.commission_type === 'amount') {
        return this.$currency.symbol
      }
      return null
    },
    suffix(tier) {
      if (tier.commission_type === 'percentage') {
        return '%'
      }
      return null
    },
  }
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.value-changed {
  border: 1px solid var(--v-success500);
}
</style>